import { Routes } from '@angular/router';
import { ReferralsGuard } from '../../../app/referrals-guard.guard';
import { legacyFaqRedirectGuard } from '../../../app/faq/legacy-faq-redirect.guard';
import { withTranslations } from '../i18n/resolvers/translations.resolvers';
import { resolveBuySellSeoSystemName } from '../route-config/infrastructure/resolvers/buy-sell-seo-system.resolver';
import { BUY_SELL_SEO_SYSTEM_NAME } from '../route-config/domain/entities/buy-sell-seo-route-data';

const buySellTranslations: ReturnType<typeof withTranslations> = withTranslations(
    'landing-for-systems',
    'landing',
);

export const marketingRoutes: Routes = [
    {
        path: 'dolar-blue-bolivia',
        loadChildren: () =>
            import('../../pages/landing-bob/landing-bob.module').then((m) => m.LandingBobModule),
        canActivate: [ReferralsGuard],
        ...withTranslations('landing-bob'),
    },
    {
        path: 'buy-sell/:system',
        loadChildren: () =>
            import('../../../app/landing-for-systems/landing-for-systems.module').then(
                (m) => m.LandingForSystemsModule,
            ),
        canActivate: [ReferralsGuard],
        ...buySellTranslations,
        resolve: {
            ...buySellTranslations.resolve,
            [BUY_SELL_SEO_SYSTEM_NAME]: resolveBuySellSeoSystemName,
        },
    },
    {
        path: 'por-que-elegir-saldoar',
        loadChildren: () =>
            import('../../../app/landing-social-proof/landing-social-proof.module').then(
                (m) => m.LandingSocialProofModule,
            ),
        canActivate: [ReferralsGuard],
        ...withTranslations('why-choose'),
    },
    {
        path: 'pedido-cancelado',
        loadChildren: () =>
            import('../../../app/wiki/help/landing-recovery/landing-recovery.module').then(
                (m) => m.LandingRecoveryModule,
            ),
        canActivate: [ReferralsGuard],
        ...withTranslations('ped-canceled'),
    },
    {
        // Legacy: redirige a /ayuda#faq (DEV-2513). El servidor ya 301-ea esto,
        // pero este guard cubre los casos donde ese redirect no corre (ng serve, etc.).
        path: 'faq',
        canActivate: [legacyFaqRedirectGuard],
    },
    {
        path: 'retirar-cobrar-paypal-a-pesos-argentina',
        loadChildren: () =>
            import('../../../app/wiki/landing-marketing/landing-marketing.module').then(
                (m) => m.LandingMarketingModule,
            ),
        canActivate: [ReferralsGuard],
        ...withTranslations('landing'),
    },
    {
        path: 'comprar-recargar-saldo-paypal-argentina',
        loadChildren: () =>
            import('../../../app/wiki/landing-marketing/landing-marketing.module').then(
                (m) => m.LandingMarketingModule,
            ),
        canActivate: [ReferralsGuard],
        ...withTranslations('landing'),
    },
];
